import { db, auth, storage, functions, COLLECTIONS } from "../../firebase/firebase";
import {
  doc,
  setDoc,
  getDoc,
  updateDoc,
  deleteDoc,
  collection,
  addDoc
} from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut
} from "firebase/auth";
import { httpsCallable } from "firebase/functions";

import { SKUser } from "../../models/SKUser";
import { CustomError } from "../../utils/customeError";
import { UserRole } from "../../context/AuthContext";

// Firestore services
const createUser = async (userId: string, data: any) => {
  await setDoc(doc(db, COLLECTIONS.USERS, userId), data, { merge: true });
};


const getUser = async (userId: string) : Promise<SKUser> => {
  const docSnap = await getDoc(doc(db, COLLECTIONS.USERS, userId));
  if (docSnap.exists()) {
    return docSnap.data() as SKUser;
  } else {
    throw new CustomError('An error occurred while getting user');
  }
};

const updateUser = async (userId: string, data: any) => {
  try {
    await updateDoc(doc(db, COLLECTIONS.USERS, userId), data);
  } catch (error) {
    console.error('An error occurred while updating user:', error);
    throw new CustomError('An error occurred while updating user');
  }
};

const deleteUser = async (userId: string) => {
  
  try {
    await deleteDoc(doc(db, "users", userId));
  } catch (error) {
    console.error('An error occurred while deleting user:', error);
    throw new CustomError('An error occurred while deleting user');
  }
};

const getUserRoleAndPermissions = async (): Promise<any> => {
  const getUserRoleAndPermissionsFunction = httpsCallable(functions, 'getUserRoleAndPermissions');
  try {
    const result = await getUserRoleAndPermissionsFunction({});
    console.log('User Role and Permissions:', result.data);
    return result
  } catch (error) {
    console.error('Error fetching user role and permissions:', error);
    throw new CustomError('Error fetching user role and permissions:');
  }
};

// Firebase Authentication services
// const registerUser = async (email: string, password: string) => {
//   const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//   return userCredential.user;
// };

// const loginUser = async (email: string, password: string) => {
//   const userCredential = await signInWithEmailAndPassword(auth, email, password);
//   return userCredential.user;
// };

// const logoutUser = async () => {
//   await signOut(auth);
// };

export {
  createUser,
  getUser,
  updateUser,
  deleteUser,
  getUserRoleAndPermissions
};